import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import "./BottomNav.css";

import {
  AddCircleRounded,
  AutoAwesomeRounded,
  CalendarMonthOutlined,
  HomeOutlined,
  CheckCircleOutline,
} from "@mui/icons-material";

const BottomNav = () => {
  const [visible, setVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY.current && window.scrollY > 80) {
        setVisible(false);
      } else {
        setVisible(true);
      }
      lastScrollY.current = window.scrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`bottom-nav ${visible ? "show" : "hide"}`}>
      <NavLink to="/" className="bottom-nav-item">
        <HomeOutlined />
        <span>Home</span>
      </NavLink>

      <NavLink to="/completed" className="bottom-nav-item">
        <CheckCircleOutline />
        <span>Completed</span>
      </NavLink>

      <NavLink to="/add" className="bottom-nav-item bottom-nav-item--primary">
        <AddCircleRounded />
        <span>Add</span>
      </NavLink>

      <NavLink to="/celebrations" className="bottom-nav-item">
        <AutoAwesomeRounded />
        <span>Celebrations</span>
      </NavLink>

      <NavLink to="/calendar" className="bottom-nav-item">
        <CalendarMonthOutlined />
        <span>Calendar</span>
      </NavLink>
    </div>
  );
};

export default BottomNav;
